import { CollapseProps } from 'antd/lib';
import React from 'react';
import { StyledCollapse } from './index.styled';

type AppCollapseProps = CollapseProps;

const AppCollapse: React.FC<AppCollapseProps> = ({ ...props }) => {
  return <StyledCollapse {...props} />;
};

export default AppCollapse;
